<template>
  <div id="app">
    <NavBar />
    <Router />
    <Footer />
  </div>
</template>

<script>
import Router from './components/Router.vue';
import NavBar from './components/NavBar.vue';
import Footer from './components/Footer.vue';

export default {
  name: 'app',
  components: {
    Router,
    NavBar,
    Footer,
  },
  data() {
    return {
      sharedStore: this.$root.store,
    };
  },
};
</script>

<style lang="scss">
@import './styles/common.scss';
@import './styles/app.scss';
</style>
